import { render, staticRenderFns } from "./IncomeTransactionForm.vue?vue&type=template&id=30f66997"
import script from "./IncomeTransactionForm.vue?vue&type=script&lang=js"
export * from "./IncomeTransactionForm.vue?vue&type=script&lang=js"
import style0 from "./IncomeTransactionForm.vue?vue&type=style&index=0&id=30f66997&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports